module.exports = __webpack_public_path__ + "media/assets/images/flags/uy-bc74d6fd7d0737a152c4d283c149f53d.svg";